const getPageScrollTop = () => {
  return (
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0
  );
};

const restorePageScrollTop = (scrollTop: number) => {
  window.scrollTo(0, scrollTop);
  document.documentElement.scrollTop = scrollTop;
  document.body.scrollTop = scrollTop;
};

const lockPageScroll = (scrollTop: number) => {
  const bodyStyle = document.body.style;
  const htmlStyle = document.documentElement.style;

  const prev = {
    bodyPosition: bodyStyle.position,
    bodyTop: bodyStyle.top,
    bodyLeft: bodyStyle.left,
    bodyRight: bodyStyle.right,
    bodyWidth: bodyStyle.width,
    bodyOverflow: bodyStyle.overflow,
    htmlOverflow: htmlStyle.overflow,
  };

  htmlStyle.overflow = "hidden";
  bodyStyle.overflow = "hidden";
  bodyStyle.position = "fixed";
  bodyStyle.top = `-${scrollTop}px`;
  bodyStyle.left = "0";
  bodyStyle.right = "0";
  bodyStyle.width = "100%";

  return () => {
    htmlStyle.overflow = prev.htmlOverflow;
    bodyStyle.overflow = prev.bodyOverflow;
    bodyStyle.position = prev.bodyPosition;
    bodyStyle.top = prev.bodyTop;
    bodyStyle.left = prev.bodyLeft;
    bodyStyle.right = prev.bodyRight;
    bodyStyle.width = prev.bodyWidth;
    restorePageScrollTop(scrollTop);
  };
};

const fallbackCopyText = (text: string) => {
  const scrollTop = getPageScrollTop();
  const unlockScroll = lockPageScroll(scrollTop);
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "readonly");
  textarea.style.position = "fixed";
  textarea.style.left = "0";
  textarea.style.top = "0";
  textarea.style.width = "1px";
  textarea.style.height = "1px";
  textarea.style.padding = "0";
  textarea.style.border = "0";
  textarea.style.opacity = "0";
  textarea.style.pointerEvents = "none";
  textarea.style.zIndex = "-1";
  document.body.appendChild(textarea);

  try {
    try {
      textarea.focus({ preventScroll: true } as any);
    } catch (error) {
      textarea.focus();
    }
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);
    const copied = document.execCommand("copy");
    if (!copied) {
      throw new Error("copy failed");
    }
  } finally {
    document.body.removeChild(textarea);
    unlockScroll();
  }
};

const copyText = async (text: string) => {
  if (!text) {
    throw new Error("copy text is empty");
  }

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch (error) {}
  }

  fallbackCopyText(text);
};

export default copyText;